import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchWrapper} from "_helpers";

// create slice

const name = "services";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({name, initialState, extraReducers});

// exports

export const servicesActions = {...slice.actions, ...extraActions};
export const servicesReducer = slice.reducer;

// implementation

function createInitialState() {
	return {
		service: {},
		services: {},
		serviceRemove: {},
		servicesRemoved: {},
		serviceAdd: {},
		serviceEdit: {},
	};
}

function createExtraActions() {
	const baseUrl = `${process.env.REACT_APP_API_URL}/externalservices`;

	return {
		get: get(),
		getAll: getAll(),
		add: add(),
		edit: edit(),
		remove: remove(),
		getAllRemoved: getAllRemoved(),
	};

	function get() {
		return createAsyncThunk(`${name}/get`, async id => await fetchWrapper.get(`${baseUrl}/${id}`));
	}

	function getAll() {
		return createAsyncThunk(`${name}/getAll`, async () => await fetchWrapper.get(baseUrl));
	}

	function getAllRemoved() {
		return createAsyncThunk(`${name}/getAllRemoved`, async () => await fetchWrapper.get(`${baseUrl}/all-removed`));
	}

	function add() {
		return createAsyncThunk(`${name}/add`, async data => await fetchWrapper.post(`${baseUrl}`, data.data));
	}

	function edit() {
		return createAsyncThunk(`${name}/edit`, async data => await fetchWrapper.put(`${baseUrl}`, data.data));
	}

	function remove() {
		return createAsyncThunk(`${name}/delete`, async ({id}) => await fetchWrapper.delete(`${baseUrl}`, {id}));
	}
}

function createExtraReducers() {
	return {
		...getAll(),
		...getAllRemoved(),
		...get(),
		...add(),
		...edit(),
		...remove(),
	};

	function getAll() {
		var {pending, fulfilled, rejected} = extraActions.getAll;
		return {
			[pending]: state => {
				state.services = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.services = action.payload;
			},
			[rejected]: (state, action) => {
				state.services = {error: action.error};
			},
		};
	}
	function getAllRemoved() {
		var {pending, fulfilled, rejected} = extraActions.getAllRemoved;
		return {
			[pending]: state => {
				state.servicesRemoved = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.servicesRemoved = action.payload;
			},
			[rejected]: (state, action) => {
				state.servicesRemoved = {error: action.error};
			},
		};
	}
	function get() {
		var {pending, fulfilled, rejected} = extraActions.get;
		return {
			[pending]: state => {
				state.service = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.service = action.payload;
			},
			[rejected]: (state, action) => {
				state.service = {error: action.error};
			},
		};
	}
	function add() {
		var {pending, fulfilled, rejected} = extraActions.add;
		return {
			[pending]: state => {
				state.serviceAdd = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.serviceAdd = action.payload;
			},
			[rejected]: (state, action) => {
				state.serviceAdd = {error: action.error};
			},
		};
	}
	function edit() {
		var {pending, fulfilled, rejected} = extraActions.edit;
		return {
			[pending]: state => {
				state.serviceEdit = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.serviceEdit = action.payload;
			},
			[rejected]: (state, action) => {
				state.serviceEdit = {error: action.error};
			},
		};
	}
	function remove() {
		var {pending, fulfilled, rejected} = extraActions.remove;
		return {
			[pending]: state => {
				state.serviceRemove = {loading: true};
			},
			[fulfilled]: (state, action) => {
				state.serviceRemove = action.payload;
			},
			[rejected]: (state, action) => {
				state.serviceRemove = {error: action.error};
			},
		};
	}
}
